
import { useForm } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import ErrorMessage from "../../Components/ErrorMessage/index"
import FormNavigation from "../FormNavigation";
import RadioGroup from "../../Components/tw/RadioGroup";
import {
  APPLY_NEW_TRADE_WASTE_PERMIT,
  APPLY_SHARED_GREASE_ARRESTOR,
  APPLY_SHORT_TERM_WASTE_DISPOSAL,
  CHANGE_DETAILS_EXISTING_WASTE_PERMIT,
  PERMIT_NUMBER,
  TRADE_WASTE_APPLICATION_TYPE,
  TRADE_WASTE_CHANGE
} from "../../Constants";
import { AnimateSharedLayout, AnimatePresence, motion } from "framer-motion";
import Input from "../../Components/Input";
import { CheckboxGroup } from "components/non_residential/react_hook_forms/CheckboxGroup";
import Unavailable from "./NewPermit/Unavailable";
import Other from "./NewPermit/Other";
import { updateAction } from "../actions";
import FoodPrep from "./NewPermit/FoodPrep";
import SharedGreaseArrestorApplication from "./SharedGreaseArrestorApplication";
import ShortTermWasteDisposal from "./ShortTermWasteDisposal";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Step1 = () => {
  const [newApplication, setNewApplication] = useState("")
  const [disabled, setDisabled] = useState<boolean>(false)
  const { actions, state } = useStateMachine({ updateAction });
  const navigate = useNavigate()
  const {
    register,
    unregister,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    getValues,
    watch,
    formState: { errors } } = useForm({
      mode: 'onSubmit',
      reValidateMode: 'onChange',
      criteriaMode: "firstError",
      shouldFocusError: true,
      shouldUnregister: true,
      defaultValues: state?.data
    });

  const application_type = watch(TRADE_WASTE_APPLICATION_TYPE);
  const new_application = watch(APPLY_NEW_TRADE_WASTE_PERMIT);
  useEffect(() => {
    new_application && console.log(new_application);

  }, [new_application]);
  const new_application_other = watch(['other']);
  const onSubmit = (data: any) => {
    actions.updateAction(data);
    if (application_type === APPLY_NEW_TRADE_WASTE_PERMIT) {
      navigate("/step2");
    }
    if (application_type === CHANGE_DETAILS_EXISTING_WASTE_PERMIT) {
      navigate("/step2b");
    }
  };
  useEffect(() => {
    setDisabled(false)
  }, [application_type])

  useEffect(() => {
    setDisabled(false)
    if ((window as any)?.dataLayer) {
      (window as any).dataLayer.push({ 'event': 'formStart' });
    }
  }, [])

  useEffect(() => {
    if (application_type === APPLY_NEW_TRADE_WASTE_PERMIT && new_application) {
      const fpExclude: Array<string> = [
        "motor_mechanical_services",
        "vehicle_washing",
        "commercial_climate_control",
        "laundry_services",
        "commercial_swimming_pool_spas",
        "hospital",
        "care_facilities",
        "veterinary_services",
        "photographic_services"
      ]
      // const fp = new_application.filter((item: string) => !fpExclude.includes(item));
      const unavailable = new_application.some(item => fpExclude.includes(item))
      if (new_application?.includes('other')) {
        setNewApplication("other")
        setDisabled(unavailable ? true : false)
      } else if (unavailable) {
        setNewApplication("unavailable")
        setDisabled(true)
      } else if (new_application.includes("food_preparation")) {
        setNewApplication("food_preparation")
        setDisabled(false)
      } else {
        setNewApplication("")
        setDisabled(false)
      }
    }
  }, [application_type, new_application, newApplication])

  useEffect(() => {
    if (application_type !== APPLY_NEW_TRADE_WASTE_PERMIT && application_type !== CHANGE_DETAILS_EXISTING_WASTE_PERMIT) {
      setDisabled(true)
    }

  }, [application_type])
  useEffect(() => {
    if (newApplication === "other" && (new_application_other?.length ?? 0) > 1) {
      setDisabled(true)
    }
  }, [newApplication, application_type])


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    errors && console.log(errors)
  }, [errors])

  return (
    <motion.div
      data-testid="step1"
      key="step1"
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
    >
      <AnimatePresence>
        {!!Object.keys(errors)?.length && (<ErrorMessage isMultiple={Object.keys(errors)?.length > 1} />)}
      </AnimatePresence>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2>Application type</h2>
        <RadioGroup
          name={TRADE_WASTE_APPLICATION_TYPE}
          legend="What would you like to do? "
          errorMessage={errors[TRADE_WASTE_APPLICATION_TYPE]?.message as string}

          radios={[
            {
              value: APPLY_NEW_TRADE_WASTE_PERMIT,
            },
            {
              value: APPLY_SHARED_GREASE_ARRESTOR,
            },
            {
              value: APPLY_SHORT_TERM_WASTE_DISPOSAL,
            },
          ]}

          registerOptions={{
            required: 'please make a selection'
          }}
          register={register}
          unregister={unregister}
        />
        <AnimateSharedLayout>
          <AnimatePresence>
            {application_type === APPLY_NEW_TRADE_WASTE_PERMIT && (
              <motion.section
                key={APPLY_NEW_TRADE_WASTE_PERMIT}
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: "auto" },
                  collapsed: { opacity: 0, height: 0 },
                }}
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                {/* New Permit */}
                <CheckboxGroup
                  name={APPLY_NEW_TRADE_WASTE_PERMIT}
                  unregister={unregister}
                  register={register}
                  registerOptions={{
                    required: "Please select at least one option"
                  }}
                  errorMessage={errors[APPLY_NEW_TRADE_WASTE_PERMIT]?.message as string}
                  legend="Please select at least one "
                  checkboxes={[
                    {
                      value: "food_preparation",
                      text: "Food preparation (e.g. Restaurant, catering , café etc.)",
                    },
                    {
                      value: "motor_mechanical_services",
                      text: "Motor mechanical services",
                    },
                    {
                      value: "vehicle_washing",
                      text: "Vehicle washing",
                    },
                    {
                      value: "commercial_climate_control",
                      text: "Commercial climate control",
                    },
                    {
                      value: "laundry_services",
                      text: "Laundry services",
                    },
                    {
                      value: "commercial_swimming_pool_spas",
                      text: "Commercial swimming pool, Spas",
                    },
                    {
                      value: "hospital",
                      text: "Hospital",
                    },
                    {
                      value: "care_facilities",
                      text: "Care facilities",
                    },
                    {
                      value: "veterinary_services",
                      text: "Veterinary services",
                    },
                    {
                      value: "photographic_services",
                      text: "Photographic services",
                    },
                    {
                      value: "other",
                      text: "Other",
                    },
                  ]}
                />

                {newApplication === 'other' && (
                  <AnimatePresence>
                    <Other
                      watch={watch}
                      unregister={unregister}
                      register={register}
                      setValue={setValue}
                      setError={setError}
                      clearErrors={clearErrors}
                      errors={errors}
                      getValues={getValues}
                    />
                  </AnimatePresence>
                )}
                {newApplication === "food_preparation" && (
                  <AnimatePresence>
                    <FoodPrep />
                  </AnimatePresence>
                )}
                {newApplication === "unavailable" && (
                  <AnimatePresence>
                    <Unavailable />
                  </AnimatePresence>
                )}
              </motion.section>
            )}
          </AnimatePresence>
          <AnimatePresence>
            {application_type === CHANGE_DETAILS_EXISTING_WASTE_PERMIT && (
              <motion.section
                key={CHANGE_DETAILS_EXISTING_WASTE_PERMIT}
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: "auto" },
                  collapsed: { opacity: 0, height: 0 },
                }}
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                <motion.div>
                  <RadioGroup
                    name={TRADE_WASTE_CHANGE}
                    legend="What do you want to change? "
                    errorMessage={errors[TRADE_WASTE_CHANGE]?.message as string}
                    radios={[
                      {
                        value: "Change contact",
                      },
                      {
                        value: "Change trading or company name",
                      },
                      {
                        value: "Change business process or type",
                      },
                      {
                        value: "I have sold the business",
                      },
                    ]}
                    registerOptions={{
                      required: 'please make a selection'
                    }}
                    register={register}
                    unregister={unregister}
                  />
                  <Input
                    name={PERMIT_NUMBER}
                    register={register}
                    label="Existing permit number (optional)"
                    type="text"
                    short={true}
                    defaultValue={(state?.data && state?.data[PERMIT_NUMBER]) || ""}
                  />
                </motion.div>
              </motion.section>
            )}
          </AnimatePresence>
          <AnimatePresence>
            {application_type === APPLY_SHARED_GREASE_ARRESTOR && (
              <motion.section
                key={APPLY_SHARED_GREASE_ARRESTOR}
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: "auto" },
                  collapsed: { opacity: 0, height: 0 },
                }}
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                <SharedGreaseArrestorApplication />
              </motion.section>
            )}
          </AnimatePresence>
          <AnimatePresence>
            {application_type === APPLY_SHORT_TERM_WASTE_DISPOSAL && (
              <motion.section
                key={APPLY_SHORT_TERM_WASTE_DISPOSAL}
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: "auto" },
                  collapsed: { opacity: 0, height: 0 },
                }}
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                <ShortTermWasteDisposal />
              </motion.section>
            )}
          </AnimatePresence>
        </AnimateSharedLayout>
        <FormNavigation isLast={false} isDisabled={disabled} />
      </form >
    </motion.div>
  );
};

export default Step1;
